import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel } from '../../models/address.model';

@Component({
	selector: 'app-contact-info-form',
	templateUrl: './contact-info-form.component.html',
	styleUrls: ['./contact-info-form.component.scss'],
})
export class ContactInfoFormComponent implements OnInit {
	@Input() displayFirstName: boolean = true;
	@Input() firstName: string;
	@Output() firstNameChange = new EventEmitter<string>();

	@Input() displayLastName: boolean = true;
	@Input() lastName: string;
	@Output() lastNameChange = new EventEmitter<string>();

	@Input() displayPhone: boolean = true;
	@Input() phone: string;
	@Output() phoneChange = new EventEmitter<string>();

	@Input() displayEmail: boolean = true;
	@Input() email: string;
	@Output() emailChange = new EventEmitter<string>();

	@Input() displayAddress: boolean = true;
	@Input() addressPlaceholder: string = 'Enter a location';
	@Input() address: AddressModel;
	@Output() addressChange = new EventEmitter<AddressModel>();

	@Input() displayButton: boolean = true;
	@Input() buttonText: string;
	@Input() buttonFaClass: string;
	@Input() buttonFaIcon: string;
	@Input() buttonClass: string;

	@Output() formComplete = new EventEmitter();

	constructor() {}

	ngOnInit(): void {
		this.buttonClass += ' p-button-raised m-2';
	}
}
